// extracted by mini-css-extract-plugin
export default {"toggleButton":"PanelToggleButtons_toggleButton__pziLH","leftToggle":"PanelToggleButtons_leftToggle__xlAs1","rightToggle":"PanelToggleButtons_rightToggle__jcJPR"};